/** How many rows to keep in the renderer buffer (soft target) */
export const BUFFER_SIZE = 20_000;
/** Trigger a refetch when viewport is within this many rows of the buffer edge */
export const REFETCH_MARGIN = 5_000;
/** Initial fetch size — enough for first screen */
export const INITIAL_FETCH_SIZE = 500;
/** Hard ceiling for window payload — shrink buffer if projected payload exceeds this */
export const WINDOW_BUDGET_BYTES = 50 * 1024 * 1024;
/** Minimum buffer rows — always covers the initial screen */
export const MIN_BUFFER_SIZE = 500;

/** Sample ≤100 rows and extrapolate to avoid full-window JSON.stringify on the renderer thread */
export function estimateWindowBytes(rows: Record<string, unknown>[]): number {
  if (rows.length === 0) return 0;
  const SAMPLE_SIZE = 100;
  if (rows.length <= SAMPLE_SIZE) {
    return JSON.stringify(rows).length * 2;
  }
  const step = Math.floor(rows.length / SAMPLE_SIZE);
  const sample: Record<string, unknown>[] = [];
  for (let i = 0; i < rows.length && sample.length < SAMPLE_SIZE; i += step) {
    sample.push(rows[i]);
  }
  const sampleBytes = JSON.stringify(sample).length * 2;
  return Math.round(sampleBytes * (rows.length / sample.length));
}
